import React from 'react';
import Shift_Master from './Shift_Master';
import '../../../CommonCSS/SocietyCSS.css'

const Shift_MasterApp = () => {
  return (
    // <div className="App">
    //   <Common_Mst />
    // </div>
    <div className="app-wrapper">
      <div className="form-container">
        <div className='card' style={{borderRadius: '8px'}}>
          <div className="card-header-css" style={{borderRadius: '8px', textAlign: 'center' }} >
            <h5>Shift Master</h5>
          </div>  
        </div>
        <Shift_Master/>
      </div>
    </div >
  );
};

export default Shift_MasterApp;
